var map = {
	"./ar.json": "./src/i18n/locales/ar.json",
	"./ca.json": "./src/i18n/locales/ca.json",
	"./de.json": "./src/i18n/locales/de.json",
	"./en.json": "./src/i18n/locales/en.json",
	"./es.json": "./src/i18n/locales/es.json",
	"./fr.json": "./src/i18n/locales/fr.json",
	"./he.json": "./src/i18n/locales/he.json",
	"./it.json": "./src/i18n/locales/it.json",
	"./pt-BR.json": "./src/i18n/locales/pt-BR.json",
	"./pt.json": "./src/i18n/locales/pt.json",
	"./zh-cn.json": "./src/i18n/locales/zh-cn.json",
	"./zh-tw.json": "./src/i18n/locales/zh-tw.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/i18n/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";